module.exports = __webpack_public_path__ + "static/lightning-card-loading-a9acdb5c50c0366733fdee5fc8a7daec.gif";